import SalesChannelDetailContent from 'pages/SalesChannels/SalesChannelDetailContent';

const APIIntegrations = () => <SalesChannelDetailContent />;

export default APIIntegrations;
